// Libs
import { StyleSheet, Text, View } from '@react-pdf/renderer';
// Components, Layouts, Pages
// Others
import { DEFAULT_CURRENCY, DEFAULT_CURRENCY_ZERO, EMPTY_STRING } from '~/utils/constants/common';
import { formatCurrency } from '~/utils/helper/common';
// Styles, images, icons
type Props = {
  title: string;
  customerName?: string;
  email?: string;
  total?: number;
};

const InformationPdf = (props: Props) => {
  //#region Destructuring Props
  const { title, customerName, email, total } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.viewText}>
        <Text style={styles.textTitle}>Customer:</Text>
        <Text style={styles.text}>{customerName || EMPTY_STRING}</Text>
      </View>
      <View style={styles.viewText}>
        <Text style={styles.textTitle}>Email:</Text>
        <Text style={styles.text}>{email || EMPTY_STRING}</Text>
      </View>
      <View style={styles.viewText}>
        <Text style={styles.textTitle}>Total:</Text>
        <Text style={styles.text}>
          {total ? formatCurrency(Number(total || DEFAULT_CURRENCY_ZERO)) : DEFAULT_CURRENCY}
        </Text>
      </View>
    </View>
  );
};

export default InformationPdf;

export const styles = StyleSheet.create({
  container: {
    // flex: 1,
  },
  viewText: {
    alignItems: 'center',
    marginTop: 5,
    flexDirection: 'row',
  },

  title: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#333333',
    borderBottomWidth: 1,
    borderColor: '#333333',
    paddingBottom: 5,
  },

  textTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#333333',
    width: 100,
  },

  text: {
    fontSize: 10,
    color: '#63667A',
  },
});
